import PropTypes from "prop-types";
import { brand } from "brand/theme";

// ==============================|| LOGO MAIN (wide wordmark) ||============================== //

export default function LogoMain({
  dark = false,
  height = 36,
  maxWidth = 168,
}) {
  return (
    <img
      src={brand.logoUrl}
      alt={brand.name}
      style={{
        // Scale to fit within the box on both axes, preserving aspect
        // ratio — a fixed height + maxWidth pair breaks (stretches or
        // overflows) whenever the wordmark's own aspect ratio doesn't
        // match what the values were tuned for.
        height: "auto",
        width: "auto",
        maxHeight: height,
        maxWidth,
        display: "block",
        // Wordmark is dark; invert when used on dark chrome
        filter: dark ? "brightness(0) invert(1)" : "none",
      }}
    />
  );
}

LogoMain.propTypes = {
  dark: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
